import { render, staticRenderFns } from "./WorkIconCircle.vue?vue&type=template&id=4c342c98"
import script from "./WorkIconCircle.vue?vue&type=script&lang=js"
export * from "./WorkIconCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports